var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogSystemEvent = function SvgLogSystemEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19319_35878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99989 11.5556C9.96357 11.5556 11.5554 9.96368 11.5554 8C11.5554 6.03632 9.96357 4.44444 7.99989 4.44444C6.03621 4.44444 4.44434 6.03632 4.44434 8C4.44434 9.96368 6.03621 11.5556 7.99989 11.5556Z",
    fill: "#C2E550",
    fillOpacity: 0.5,
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19319_35878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogSystemEvent as ReactComponent };
export default __webpack_public_path__ + "log-system-event.svg";